import { useCallback } from 'react';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildQueryString, buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
const api = buildService('/time_tracking/companies', {
  only: ['all']
});
export const companiesService = {
  useFetchAllCompanies(setLoading, initialQueryParams) {
    initialQueryParams || (initialQueryParams = {
      page: 1
    });
    const [taskCompanies, setTaskCompanies, fetchTaskCompanies] = serviceMethods.useFetch({
      callback: useCallback(async queryParams => await api.all(queryParams), []),
      setLoading,
      initialQueryParams
    });
    return [taskCompanies, setTaskCompanies, fetchTaskCompanies];
  },
  all: function () {
    let queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return fetch("/api/time_tracking/companies?".concat(queryParams), request.get);
  }
};